// Render legacy level message
import React from "react";

const LegacyLevel = (props) => {
  return (
    <div className="component-legacy-level">
      In 2019, The cost of Stainless Steel membership increased to $12/month.
      Long-standing members like you pay just $8/month, but upgrading your
      support to the new price would be a significant help. Thank you for being
      a Long Now member all these years!
    </div>
  );
};
export default LegacyLevel;
